import { Pipe, PipeTransform } from '@angular/core';
import { ContractStatus } from '../enum/contract-status.enum';

@Pipe({
  name: 'ContractStatus',
  standalone: true,
})
export class ContractStatusPipe implements PipeTransform {
   /**
   * Transforms the ContractStatus enum value into a user-friendly string.
   * @param value - The ContractStatus enum value to transform.
   * @returns A string representation of the ContractStatus.
   */
  transform(value: ContractStatus | null) {

    if (value == ContractStatus.active) {
      return 'contract.statusEnum.active';
    } else if (value == ContractStatus.expired) {
      return 'contract.statusEnum.expired';
    } else {
      return ''; // Return 'default' for unrecognized statuses
    }
  }
}
